var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeZoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,24c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S42.627,24,36,24z M36,46   c-5.523,0-10-4.477-10-10s4.477-10,10-10s10,4.477,10,10S41.523,46,36,46z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 1.5,
    width: 1.5,
    x: 35.25,
    y: 27.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 1.5,
    width: 1.5,
    x: 27.5,
    y: 35.25
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 1.5,
    transform: "matrix(0.7068 0.7074 -0.7074 0.7068 33.7364 -20.4359)",
    width: 1.501,
    x: 40.77,
    y: 29.729
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 1.5,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 22.868 92.3511)",
    width: 1.5,
    x: 29.811,
    y: 40.69
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 1.501,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 30.5199 -12.6415)",
    width: 1.5,
    x: 29.77,
    y: 29.77
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#212529",
    height: 1.5,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 41.4805 100.1427)",
    width: 1.5,
    x: 40.731,
    y: 40.731
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212529",
    points: "35.25,35.25 35.25,36 35.25,36.75 35.25,43 35.25,44.5 36.75,44.5 36.75,43 36.75,36.75 43,36.75    44.5,36.75 44.5,35.25 43,35.25  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.015,47.222c0.017-0.001,0.032-0.005,0.049-0.007c-0.027-0.024-0.052-0.054-0.079-0.078   C25.994,47.164,26.005,47.194,26.015,47.222z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.403,34.099c-0.215-0.463-0.319-0.724-0.319-0.724h5.16c0.596-3.369,2.313-6.342,4.756-8.533V19.25   h7.566c0.096,0.635,0.167,1.28,0.218,1.932C34.509,21.074,35.245,21,36,21c0.543,0,1.077,0.032,1.604,0.088   c-0.043-0.618-0.099-1.232-0.174-1.838h6.155C43.856,20.562,44,21.92,44,23.312c0,0.005-0.001,0.009-0.001,0.014   c1.428,0.903,2.692,2.034,3.739,3.351C47.894,25.575,48,24.458,48,23.312c0-12.576-9.675-22.886-21.986-23.91   C26.009-0.6,26.005-0.604,26-0.607v0.009c-0.66-0.054-1.326-0.089-2-0.089s-1.34,0.035-2,0.089v-0.009   c-0.005,0.003-0.009,0.007-0.014,0.01C9.675,0.427,0,10.736,0,23.312s9.674,22.886,21.986,23.909   c0.005,0.004,0.009,0.008,0.014,0.011v-0.01c0.66,0.055,1.326,0.09,2,0.09s1.34-0.035,2-0.09v0.01   c0.005-0.003,0.01-0.007,0.015-0.011c-3.987-3.825-6.612-7.686-8.157-10.355C17.318,35.99,16.836,35.063,16.403,34.099z    M42.295,15.25h-5.626c-1.002-3.905-2.704-7.44-4.943-10.388C36.443,6.84,40.232,10.578,42.295,15.25z M26,4.818   c2.988,2.605,5.321,6.223,6.647,10.432H26V4.818z M22,29.375h-7.183c-0.443-1.932-0.688-3.962-0.688-6.062   c0-1.387,0.106-2.744,0.304-4.062H22V29.375z M22,4.818V15.25h-6.647C16.679,11.041,19.012,7.423,22,4.818z M16.274,4.862   c-2.239,2.947-3.941,6.483-4.943,10.388H5.706C7.768,10.578,11.557,6.84,16.274,4.862z M4.941,29.375   C4.333,27.462,4,25.427,4,23.312c0-1.392,0.144-2.75,0.415-4.062h6.154c-0.165,1.326-0.256,2.681-0.256,4.062   c0,2.085,0.204,4.111,0.571,6.062H4.941z M6.735,33.375h5.182c1.027,3.114,2.508,5.953,4.358,8.388   C12.253,40.077,8.915,37.106,6.735,33.375z",
    fill: "#212529"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeZoneIcon);
export default __webpack_public_path__ + "static/media/timeZoneIcon.7713274c01bfa21151fe817f343e0376.svg";
export { ForwardRef as ReactComponent };